export default {
    setMenu(state, payload) {
        state.menu = payload.menu;
    },
    setMenuState(state, payload) {
        state.menuOpened = payload
    },
}